import Product from 'cpc-license-manager/models/product';
import { belongsTo } from '@ember-data/model';

class Kitting extends Product {
  @belongsTo('station-feature', { async: false, inverse: null, embedded: true }) features;

  name = 'kitting';
  label = 'Kitting';
}

export default Kitting;
